import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import _isEqual from 'lodash/isEqual';

import {withStyles} from '@material-ui/core/styles';

import _get from 'lodash/get';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';

import {Dropdown, RenderDivOrEmpty} from '../index';
import {PERIODS} from '../../constants';

import {Refresh} from '../../icons/index';

import style from './style';

class DashboardOperatorFiltersPanel extends Component {
  static shouldReloadDashboard(prevProps, props) {
    return (
      !_isEqual(
        prevProps.loggedAccount.accountId,
        props.loggedAccount.accountId,
      ) ||
      !_isEqual(
        _get(prevProps.currentOrganization, 'id', null),
        _get(props.currentOrganization, 'id', null),
      ) ||
      !_isEqual(props.searchOptions, prevProps.searchOptions)
    );
  }

  constructor(props) {
    super(props);

    this.campusesOptions = [];
    this.campusesOptions.push(I18n.t('dashboard.filters.ALL_CAMPUSES'));

    this.profilesOptions = [];
    this.profilesOptions.push(I18n.t('dashboard.filters.ALL_PROFILES'));

    this.periodsOptions = [];
    this.periodsOptions.push(
      ...Object.keys(PERIODS).map((period) =>
        I18n.t(`dashboard.filters.${period}`),
      ),
    );
  }

  componentDidMount() {
    this.handleClickOnButtonRefresh();
  }

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(this.props.campuses, nextProps.campuses) ||
      !_isEqual(this.props.selectedCampusIndex, nextProps.selectedCampusIndex) ||
      !_isEqual(this.props.profiles, nextProps.profiles) ||
      !_isEqual(this.props.selectedPeriodIndex, nextProps.selectedPeriodIndex) ||
      !_isEqual(this.props.loggedAccount, nextProps.loggedAccount) ||
      !_isEqual(_get(this.props.currentOrganization, 'id', null), _get(
        nextProps.currentOrganization, 'id', null)) ||
      !_isEqual(this.props.selectedProfileIndex, nextProps.selectedProfileIndex)
    );
  }

  componentDidUpdate(prevProps) {
    if (DashboardOperatorFiltersPanel.shouldReloadDashboard(prevProps, this.props)) {
      this.resetLocalState();
    }
  }

  getCampusesOptions = () => {
    const {campuses} = this.props;
    if (campuses.length === this.campusesOptions.length - 1) {
      return this.campusesOptions;
    }
    return [...this.campusesOptions, ...campuses.map((item) => item.name)];
  };

  getprofilesOptions = () => {
    const {profiles} = this.props;
    if (!profiles || !Array.isArray(profiles)) {
      return [I18n.t('dashboard.filters.ALL_PROFILES')];
    }
    return [
      I18n.t('dashboard.filters.ALL_PROFILES'),
      ...profiles.map((profile) => profile?.name || ''),
    ];
  };

  resetLocalState = () =>
    this.setState(DashboardOperatorFiltersPanel.initialLocalState, () =>
      this.handleClickOnButtonRefresh(),
    );

  handleChangeCampus = (e) => {
    this.props.onSelectedCampusChange(e.target.value);
  };

  handleChangeProfile = (e) => {
    this.props.onSelectedProfileChange(e.target.value);
  };

  handleChangePeriod = (e) => {
    this.props.onSelectedPeriodChange(e.target.value);
  };

  handleClickOnButtonRefresh = () => {
    const {
      campuses,
      profiles,
      selectedPeriodIndex,
      selectedCampusIndex,
      selectedProfileIndex,
      currentOrganization,
    } = this.props;

    let campusId = null;
    let profileId = null;
    const campusIndex = parseInt(selectedCampusIndex, 10);
    if (campusIndex > 0) {
      campusId = campuses[campusIndex - 1].id;
    }
    const profileIndex = parseInt(selectedProfileIndex, 10);
    if (profileIndex > 0) {
      profileId = profiles[profileIndex - 1].id;
    }
    this.props.handleRefresh({
      period: this.periodsOptions[selectedPeriodIndex],
      campusId: campusId,
      profileId: profileId,
      organizationId: currentOrganization?.id,
    });
  };

  render() {
    const {
      classes,
      selectedPeriodIndex,
      selectedCampusIndex,
      selectedProfileIndex,
      deviceAgentAllowed,
    } = this.props;
    return (
      <div className={classes.filtersPanel}>
        <div className={classes.filtersPanel__container}>
          <div className={classes.filtersPanel__item}>
            <Dropdown
              options={this.getCampusesOptions()}
              selectedItemIndex={selectedCampusIndex}
              customSelectClass="dropdown__select_dashboard"
              onChangeValue={this.handleChangeCampus}
              customFormControlClass="dropdown__formControl_noPadding"
            />
          </div>
          <RenderDivOrEmpty
            isShow={deviceAgentAllowed}
            className={classes.filtersPanel__item}
          >
            <Dropdown
              options={this.getprofilesOptions()}
              selectedItemIndex={selectedProfileIndex}
              customSelectClass="dropdown__select_dashboard"
              onChangeValue={this.handleChangeProfile}
              customFormControlClass="dropdown__formControl_noPadding"
            />
          </RenderDivOrEmpty>
          <div className={classes.filtersPanel__item}>
            <Dropdown
              options={this.periodsOptions}
              selectedItemIndex={selectedPeriodIndex}
              customSelectClass="dropdown__select_dashboard"
              onChangeValue={this.handleChangePeriod}
              customFormControlClass="dropdown__formControl_noPadding"
            />
          </div>
          <div className={classes.filtersPanel__item}>
            <CustomButton
              color="secondary"
              onClick={this.handleClickOnButtonRefresh}
              size="sm"
            >
              <Refresh />
              <span className={classes.buttonRefresh_text}>
                {I18n.t('buttons.refresh').toUpperCase()}
              </span>
            </CustomButton>
          </div>
        </div>
      </div>
    );
  }
}

DashboardOperatorFiltersPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  campuses: PropTypes.array,
  profiles: PropTypes.array,
  handleRefresh: PropTypes.func.isRequired,
  onSelectedPeriodChange: PropTypes.func.isRequired,
  onSelectedCampusChange: PropTypes.func.isRequired,
  onSelectedProfileChange: PropTypes.func.isRequired,
  selectedPeriodIndex: PropTypes.number.isRequired,
  selectedCampusIndex: PropTypes.number.isRequired,
  selectedProfileIndex: PropTypes.number.isRequired,
  loggedAccount: PropTypes.object.isRequired,
  currentOrganization: PropTypes.object,

  deviceAgentAllowed: PropTypes.bool,
};

DashboardOperatorFiltersPanel.defaultProps = {
  campuses: [],
  profiles: [],
  currentOrganization: null,
  deviceAgentAllowed: false,
};

export default withStyles(style)(DashboardOperatorFiltersPanel);
